import { EXTRA_COST_RESOURCE } from '../api/resources';
import { createResourceSlice } from '../store/resource/createResourceSlice';

const extraCostsSlice = createResourceSlice({
    resource: EXTRA_COST_RESOURCE,
    byKey: 'customerId',
});

export const {
    indexFulfilled,
    showFulfilled,
    storeFulfilled,
    updateFulfilled,
    destroyFulfilled,

    indexExtraCosts,
    showExtraCost,
    storeExtraCost,
    updateExtraCost,
    archiveExtraCost,
    restoreExtraCost,
    destroyExtraCost,
} = extraCostsSlice.actions;

export const {
    selectExtraCostById,
    makeExtraCostsByIdsSelector,
    selectAllExtraCostIds,
    selectAllExtraCosts,
    selectExtraCostsLoading,
    selectExtraCostsInitialized,
    selectExtraCostLoading,
    selectExtraCostInitialized,
    selectExtraCostIdsByCustomerId,
    makeExtraCostByCustomerIdSelector,
    selectExtraCostLoadingByCustomerId,
    selectExtraCostInitializedByCustomerId,
} = extraCostsSlice.selectors;

export const { useExtraCosts, useExtraCost, useExtraCostsByCustomerId} = extraCostsSlice.hooks;

export default extraCostsSlice.reducer;
